import axios from '@/plugins/axios.js';

export default {
    namespaced: true,

    state: {
        isTurnItInIntegrationEnabled: false,
        isVitalSourceInIntegrationEnabled: false,
        turnitinDeploymentId: null,
        vitalSourceDeploymentId: null,
        ebookProviders: [],
        ebookDeclineReportFormats: [],
    },

    mutations: {
        SET_TURNITIN_INTEGRATION_DATA(state, data) {
            state.isTurnItInIntegrationEnabled = data.enabled;
            state.turnitinDeploymentId = data.deployment_id;
        },
        SET_VITALSOURCE_INTEGRATION_DATA(state, data) {
            state.isVitalSourceInIntegrationEnabled = data.enabled;
            state.vitalSourceDeploymentId = data.deployment_id;
        },
        SET_TURNITIN_AVAILABLE(state, enabled) {
            state.isTurnItInIntegrationEnabled = enabled;
        },
        SET_EBOOK_PROVIDERS(state, providers) {
            state.ebookProviders = providers;
        },
        SET_EBOOK_DECLINE_REPORT_FORMATS(state, formats) {
            state.ebookDeclineReportFormats = formats;
        },
    },

    actions: {
        async getAllIntegrations() {
            const response = await axios.get('/api/integrations/tool/list');
            return response;
        },

        async getIntegrationById({ commit }, id) {
            const response = await axios.get(`/api/integrations/tool/${id}`);
            return response;
        },

        async enableIntegration({ commit }, id) {
            await axios.post(`/api/integrations/lti/register/${id}/enable`);
        },

        async disableIntegration({ commit }, id) {
            await axios.post(`/api/integrations/lti/register/${id}/disable`);
        },

        async getTurnitinRelatedInfo({ commit }) {
            const { data } = await axios.get('/api/integrations/get-turnitin-integration-info');
            commit('SET_TURNITIN_INTEGRATION_DATA', data);
            return data.enabled;
        },

        async getVitalSourceRelatedInfo({ commit }) {
            const { data } = await axios.get('/api/integrations/get-vitalsource-integration-info');
            commit('SET_VITALSOURCE_INTEGRATION_DATA', data);
            return data.enabled;
        },
    },
};
